//so that the screen does not get pushed to the browserhistory stack.
const checkActive = (url) => {
  if (url === window.location.pathname) return true;
  return false;
};

export { checkActive };
